/**
 * Convert a number into text
 * @param {number} c decimal number
 * @param {string} d decimal separator
 * @param {string} t thousands separator
 * @return {string} the number written in the specified format
 */
Number.prototype.formatNumber = function(c, d, t){
	c = isNaN(c = Math.abs(c)) ? 2 : c
	d = d === undefined ? "." : d
	t = t === undefined ? "," : t
	let n = this,
		s = n < 0 ? "-" : "",
		i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
		j = i.length > 3 ? i.length % 3 : 0
	return s + (j ? i.substring(0, j) + t : "") + i.substring(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "")
}

/**
 * Search a string or regular expression on this string and determine if it matches or not
 * @param {string} value value to search on
 * @param {string | RegExp} regexp value or regular expression being searched for
 * @return {boolean} true if the values match, false otherwise
 */
export const normalizeAndSearch = (value, regexp) => {
	return value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").search(regexp.toLowerCase()) > -1
}

(function () {
	// On page load or when changing themes, best to add inline in `head` to avoid FOUC
	if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
		document.documentElement.classList.add('dark')
	} else {
		document.documentElement.classList.remove('dark')
	}
})()